<template>
  <header class="detail-header">
    <button
      class="detail-header__back"
      @click="backHomePageHandler"
      aria-label="Wstecz"
    >
      <svg viewBox="0 0 24 24" class="icon">
        <polyline points="15 18 9 12 15 6" />
      </svg>
    </button>

    <div class="plate" aria-label="Numer rejestracyjny">
      <div class="plate__eu">
        <svg class="plate__stars" viewBox="-20 -20 40 40" aria-hidden="true">
          <g
            v-for="n in 12"
            :key="n"
            :transform="`rotate(${(n - 1) * 30}) translate(0,-13.5)`"
          >
            <path
              d="M0,-2.4 L0.71,-0.74 L2.28,-0.74 L1.02,0.28 L1.41,1.94 L0,0.9 L-1.41,1.94 L-1.02,0.28 L-2.28,-0.74 L-0.71,-0.74 Z"
            />
          </g>
        </svg>
        <span class="plate__country">PL</span>
      </div>
      <span class="plate__number">{{ getOrderNumber }}</span>
    </div>
  </header>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "DetailsHeader",
  computed: {
    ...mapGetters(["getOrderNumber"]),
  },
  methods: {
    backHomePageHandler() {
      this.$router.push({ name: "Home" });
    },
  },
};
</script>
